
export const environment = {
    production :true,
    name:"(prod)",
    apiBaseUrl:"http://jlivex.com/api"
}